import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AvoidForeclosure from "@/pages/tools/AvoidForeclosure";

export const Route = createFileRoute("/tools/avoid-foreclosure")({
  head: () => seoHead("/tools/avoid-foreclosure"),
  component: AvoidForeclosure,
});
